import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getAccessRights() {
        try{            
            //used in login - retrieving list of user app access - no restriction
            const response = await axios.get(`Apps/accessrights`)                  
            return response
        }catch (error){
            console.log('Apps api getAccessRights error')
            throw error
        }
    },
    async getAccessRightsSummary() {
        try{            
            const response = await axios.get(`Apps/accessrights/summary`, {
                headers: {
                    'page_key': pageKeys.apps
                }
            })                   
            return response
        }catch (error){
            console.log('Apps api getAccessRightsSummary error')
            throw error
        }
    },
    async getAll(userId) {
        try{            
            const response = await axios.get(`Apps/${userId}`, {
                headers: {
                    'page_key': pageKeys.apps
                }
            })                   
            return response
        }catch (error){
            console.log('Apps api getAll error')
            throw error
        }
    },
    async updateAccessRights(data, userId) {
        try{            
            const response = await axios.post(`Apps/accessrights/${userId}`, 
            {
                items: data
            },
            {
                headers: {
                    'page_key': pageKeys.apps
                }
            })             
            return response
        }catch (error){
            console.log('Apps api updateAccessRights error')
            throw error
        }
    },
    async approveAccessRights(data, userId) {
        try{            
            const response = await axios.post(`Apps/accessrights/approve/${userId}`, 
            {
                items: data
            },
            {
                headers: {
                    'page_key': pageKeys.apps
                }
            })              
            return response
        }catch (error){
            console.log('Apps api approveAccessRights error')
            throw error
        }
    },
    async rejectAccessRights(data, userId) {
        try{            
            const response = await axios.post(`Apps/accessrights/reject/${userId}`, 
            {
                items: data
            },
            {
                headers: {
                    'page_key': pageKeys.apps
                }
            })             
            return response
        }catch (error){
            console.log('Apps api rejectAccessRights error')
            throw error
        }
    },
    async saveTemplate(data) {
        try{            
            const response = await axios.post(`Apps/accessrights/save-as-template`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.apps
                }
            })             
            return response
        }catch (error){
            console.log('Apps api saveAsTemplate error')
            throw error
        }
    },
    async getTemplates() {
        try{            
            const response = await axios.get(`Apps/accessrights/templates`, {
                headers: {
                    'page_key': pageKeys.apps
                }
            })                   
            return response
        }catch (error){
            console.log('Apps api getTemplates error')
            throw error
        }
    },
    async copyTemplate(data) {
        try{            
            const response = await axios.post(`Apps/accessrights/copy-template`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.apps
                }
            })             
            return response
        }catch (error){
            console.log('Apps api copyTemplate error')
            throw error
        }
    },
    async updateFavorite(data) {
        try{            
            const response = await axios.post(`Apps/favorite/${data.appPageId}/${data.added}`, 
            {},
            {
                headers: {
                    'page_key': pageKeys.apps
                }
            })             
            return response
        }catch (error){
            console.log('Apps api updateFavorite error')
            throw error
        }
    },
    async getUIVersions() {
        try{            
            const response = await axios.get(`Apps/ui-versions`)                   
            return response
        }catch (error){
            console.log('Apps api getUIVersions error')
            throw error
        }
    },
}